export default [
  {
    path: '/board/barBoard',
    component: () => import('@/views/board/barBoard/Index.vue'),
    name: 'board-barBoard',
    meta: {
      auth: 0,
      backgroundClass: 'bg-dark',
      title: 'AE8实时销售表',
    },
  },
  // 胎压监测
  {
    path: '/board/tirePressure-:vinNo',
    component: () => import('@/views/board/tirePressure/Index.vue'),
    name: 'board-tirePressure',
    meta: {
      auth: 1,
      backgroundClass: 'bg-gray',
      title: '胎压监测',
    },
  },
  {
    path: '/board/tirePressure/instruction',
    component: () => import('@/views/board/tirePressure/Instruction.vue'),
    name: 'board-tirePressure-instruction',
    meta: {
      auth: 0,
      backgroundClass: 'bg-gray',
      title: '胎压计小贴士',
    },
  },
  {
    path: '/board/tirePressure/sensorBinding',
    component: () => import('@/views/board/tirePressure/Sensor.vue'),
    name: 'board-tirePressure-sensorBinding',
    meta: {
      auth: 1,
      appName: 'TirePressureSensorBinding',
      backgroundClass: 'bg-gray',
      title: '绑定胎压传感器',
    },
  },
  {
    path: '/board/tirePressure/sensorSetting',
    component: () => import('@/views/board/tirePressure/Sensor.vue'),
    name: 'board-tirePressure-sensorSetting',
    meta: {
      auth: 1,
      appName: 'TirePressureSensorSetting',
      backgroundClass: 'bg-gray',
      title: '设置胎压传感器',
    },
  },
];
